import { render, staticRenderFns } from "./MyVueUploadComponent.vue?vue&type=template&id=73144930"
import script from "./MyVueUploadComponent.vue?vue&type=script&lang=js"
export * from "./MyVueUploadComponent.vue?vue&type=script&lang=js"
import style0 from "./MyVueUploadComponent.vue?vue&type=style&index=0&id=73144930&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports